module.exports = __webpack_public_path__ + "img/Icon-BranchManagement.f13e3ef4.svg";